import moment from "moment";
import { UNDETERMINED_FUTURE } from "PFApp/constants/dates";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";

import { useMyAccountInfo } from "./queries/account/use_my_account_info";

const useAvailabilityLimits = () => {
  const { formatISODate } = useDateFormatter();

  const {
    data: { availability }
  } = useMyAccountInfo();

  const monthsLimit = availability?.calculated_months_limit ? availability.calculated_months_limit - 1 : 6;

  const maxDate = formatISODate(UNDETERMINED_FUTURE.clone().endOf("month"));
  const minDate = formatISODate(moment().subtract(monthsLimit, "months").startOf("month"));

  return {
    maxDate,
    minDate
  };
};

export default useAvailabilityLimits;
